export const getAriaLabel = (type, hasValue) => {
    if (type === 'image') {
        return hasValue ? 'Change image' : 'Upload image';
    }
    return hasValue ? 'Change file' : 'Upload file';
};
export const getTitle = (type, t) => {
    return type === 'image' ? t('file-upload.title.image') : t('file-upload.title.default');
};
export const getContainerClassName = (size) => {
    return size === 'small' ? 'small' : 'large';
};
export const getEnabledLabelClassName = () => {
    return '';
};
export const getDisabledLabelClassName = () => {
    return 'disabled';
};
export const getLabelStyle = (disabled) => {
    return {
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
    };
};
export const getDataTestId = (baseId, suffix) => {
    return baseId ? `${baseId}-${suffix}` : undefined;
};
export const shouldShowClearButton = (disabled, showClearButton) => {
    return !disabled && showClearButton;
};
export const shouldShowPreview = (previewUrl, type) => {
    return Boolean(previewUrl && type === 'image');
};
export const shouldShowFileInfo = (value, type) => {
    return Boolean(value && type === 'default');
};
